import React, { Component } from 'react';
import { Form, FormFeedback, Input } from 'reactstrap';
import defaultPropertiesUpdateFn from '../../models/form/defaultPropertiesUpdateFn';
import withValidator from '../../models/form/withValidator';
import employeeIdentifierRules from '../../models/form/rules/employee-identifier';
import firstNameRules from '../../models/form/rules/first-name';
import lastNameRules from '../../models/form/rules/last-name';
import LoadingButton from '../../../shared/ui/LoadingButton';

const validatorConfig = {
  cssClasses: {
    fieldInvalid: 'is-invalid',
    fieldValid: 'is-valid',
  },
  fields: {
    employeeIdentifier: { rules: employeeIdentifierRules },
    firstName: { rules: firstNameRules },
    lastName: { rules: lastNameRules },
  },
};

class UserDetailForm extends Component {
  constructor(props) {
    super(props);
    this.state = {
      cssValidationClasses: {
        employeeIdentifier: '',
        firstName: '',
        lastName: '',
      },
      properties: {
        employeeIdentifier: this.props.initialValues.employeeIdentifier,
        email: this.props.initialValues.email,
        firstName: this.props.initialValues.firstName,
        gender: this.props.initialValues.gender,
        lastName: this.props.initialValues.lastName,
      },
      errorFeedback: {},
      isFormDisabled: true,
    };
  }

  componentDidMount() {
    if (this.props.initialValues) {
      this.props.initialize({
        employeeIdentifier: this.state.properties.employeeIdentifier,
        firstName: this.state.properties.firstName,
        lastName: this.state.properties.lastName,
      });
    }
  }

  componentWillReceiveProps(nextProps) {
    this.setState({
      cssValidationClasses: nextProps.cssValidationClasses,
      errorFeedback: nextProps.errorFeedback,
      isFormDisabled:
        nextProps.hasErrors || !Object.keys(nextProps.touched).length,
    });
  }

  // ----------------------
  // Methods
  // ----------------------

  handleBlur(event) {
    const { name, value } = event.target;
    this.props.touch(name);
    this.props.validateField(name, value);
  }

  handleInput(event) {
    const { name, value } = event.target;
    const callback = () => {
      if (Object.keys(this.state.cssValidationClasses).includes(name)) {
        this.props.validateField(name, value);
      }
      if (name === 'gender') {
        this.props.touch(name);
      }
    };
    this.setState(defaultPropertiesUpdateFn(name, value), callback);
  }

  handleSelect(event) {
    const { name, value } = event.target;
    this.setState(defaultPropertiesUpdateFn(name, value));
  }

  handleSubmit(event) {
    event.preventDefault();
    const properties = {
      employeeIdentifier: this.state.properties.employeeIdentifier,
      firstName: this.state.properties.firstName,
      gender: this.state.properties.gender,
      lastName: this.state.properties.lastName,
    };
    this.props.onSave(properties);
  }

  // ----------------------
  // Render
  // ----------------------

  render() {
    return (
      <Form noValidate onSubmit={event => this.handleSubmit(event)}>
        <div className="form-group">
          <label htmlFor="email">
            Email <i className="fa fa-asterisk" />
          </label>
          <Input
            disabled
            id="email"
            name="email"
            type="text"
            value={this.state.properties.email}
          />
          <FormFeedback>{this.state.errorFeedback.email}</FormFeedback>
        </div>
        <div className="form-group">
          <label htmlFor="firstName">
            First Name <i className="fa fa-asterisk" />
          </label>
          <Input
            className={this.state.cssValidationClasses.firstName}
            id="firstName"
            name="firstName"
            onBlur={event => this.handleBlur(event)}
            onChange={event => this.handleInput(event)}
            type="text"
            value={this.state.properties.firstName}
          />
          <FormFeedback>{this.state.errorFeedback.firstName}</FormFeedback>
        </div>
        <div className="form-group">
          <label htmlFor="lastName">
            Last Name <i className="fa fa-asterisk" />
          </label>
          <Input
            className={this.state.cssValidationClasses.lastName}
            id="lastName"
            name="lastName"
            onBlur={event => this.handleBlur(event)}
            onChange={event => this.handleInput(event)}
            type="text"
            value={this.state.properties.lastName}
          />
          <FormFeedback>{this.state.errorFeedback.lastName}</FormFeedback>
        </div>
        <div className="form-group">
          <label htmlFor="employeeIdentifier">
            Employee ID <i className="fa fa-asterisk" />
          </label>
          <Input
            className={this.state.cssValidationClasses.employeeIdentifier}
            id="employeeIdentifier"
            name="employeeIdentifier"
            onBlur={event => this.handleBlur(event)}
            onChange={event => this.handleInput(event)}
            placeholder="Employee ID"
            type="text"
            value={this.state.properties.employeeIdentifier}
          />
          <FormFeedback>
            {this.state.errorFeedback.employeeIdentifier}
          </FormFeedback>
        </div>
        <div style={{ textAlign: 'right' }}>
          <LoadingButton
            primary
            isLoading={this.props.isLoading}
            text="Submit"
            disabled={this.state.isFormDisabled}
          />
        </div>
      </Form>
    );
  }
}

export default withValidator(UserDetailForm, validatorConfig);
